//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/js/utils';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import UserAccessLogs from '@/modules/tasks/datastudio/components/UserAccessLogs.vue';
import UserAccessDetails from '@/modules/tasks/datastudio/components/UserAccessDetails.vue';
import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import { textsDefaul } from "@/js/constants";
export default {
  name: 'VisualizationUserAccessGDS',
  components: {
    UserAccessLogs: UserAccessLogs,
    UserAccessDetails: UserAccessDetails
  },
  data: function data() {
    return {
      items: [],
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      modalName: 'Assign User',
      modalUserAccessObject: 'modalUserAccessObject',
      modalUserAccessNew: 'modalUserAccessNew',
      modalUserAccessLogs: 'modalUserAccessLogs',
      record: Object,
      expanded: [],
      pagination: {
        current: 1,
        limit: 10,
        offset: 0,
        total: 0
      }
    };
  },
  created: function created() {
    this.getItems();
  },
  computed: {
    fields: function fields() {
      return [{
        key: 'report',
        label: this.traductor('my_tasks.tablas_tasks.report'),
        class: 'w-30'
      }, {
        key: 'data_operator',
        label: this.traductor('tablas.data_operator'),
        class: 'w-40'
      }, {
        key: 'actions',
        label: this.traductor('tablas.actions'),
        class: 'w-30'
      }];
    },
    headers: function headers() {
      return [{
        value: 'report',
        text: this.traductor('my_tasks.tablas_tasks.report')
      }, {
        value: 'data_operator',
        text: this.traductor('my_tasks.tablas_tasks.operator')
      }, {
        value: 'actions',
        text: this.traductor('my_tasks.tablas_tasks.actions')
      }];
    },
    texts: function texts() {
      return {
        email: this.traductor('frases.email'),
        new_email: this.traductor('frases.new_email'),
        permission: this.traductor('frases.permission'),
        logs: this.traductor('frases.logs'),
        download: this.traductor('botones.boton_descargar_csv')
      };
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    clickedRow: function clickedRow(value) {
      if (this.expanded.length && this.expanded[0].id == value.id) {
        this.expanded = [];
      } else {
        this.expanded = [];
        this.expanded.push(value);
      }
    },
    getItems: function getItems() {
      var _this = this;
      var params = {
        domain: window.userInfo.domain
      };
      this.isBusy = !this.isBusy;
      DatastudioReportService.getUserAccess(params).then(function (response) {
        _this.isBusy = !_this.isBusy;
        _this.items = response.data;
        console.log("items", _this.items);
      });
    },
    showModalUserAccessObject: function showModalUserAccessObject(data) {
      this.record = utils.cloneJSON(data.item);
      this.$root.$emit('bv::show::modal', this.modalUserAccessObject, '#btnShow');
    },
    showModalUserAccessNew: function showModalUserAccessNew(data) {
      this.record = utils.cloneJSON(data.item);
      this.$root.$emit('bv::show::modal', this.modalUserAccessNew, '#btnShow');
    },
    showModalUserAccessLogs: function showModalUserAccessLogs(data) {
      this.record = utils.cloneJSON(data.item);
      this.$root.$emit('bv::show::modal', this.modalUserAccessLogs, '#btnShow');
    },
    downloadMassive: function downloadMassive() {
      var _this2 = this;
      DatastudioReportService.download_all().then(function (response) {
        _this2.downloadAction({
          name: 'Visualization_User_Access'
        }, response.data);
      });
    },
    downloadData: function downloadData(data) {
      var _this3 = this;
      var params = {
        record: {
          document_id: data.report_id
        }
      };
      console.log(params);
      return DatastudioReportService.download_all(params).then(function (response) {
        _this3.downloadAction(data, response.data);
      });
    },
    downloadAction: function downloadAction() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Array;
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + body);
      a.href = url;
      a.download = "".concat(item.email, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
};